import moment from 'moment';

export const getAge = value => {
  return moment().diff(value, 'years', false);
};
